import React, { PureComponent } from "react";

import KnowledgeBaseCard from "../components/knowledge-base/KnowledgeBaseCard";
import KnowledgeBaseContent from "../components/knowledge-base/KnowledgeBaseContent";
import { addUserSpecificParams, detectMobile } from "../services/utils";
import TypeformModal from "../components/typeform/modal";

import orderBy from "lodash/orderBy";

const getOrderedList = items => orderBy(items, ["order"], ["asc"]);

class KnowledgeBase extends PureComponent {
  constructor(props) {
    super(props);

    this.isMobile = detectMobile();
  }

  render() {
    return (
      <section className="knowledge bg-gray">
        <div className="row">
          <h3 className="h3-icon semibold">Knowledge Base</h3>
          <div className="row">
            {getOrderedList(KnowledgeBaseContent).map(({ key, url, title }) => (
              <div key={`knowledge-base-${key}`} className="col-md-3 col-xs-12">
                <KnowledgeBaseCard
                  title={title}
                  url={addUserSpecificParams(url)}
                  isMobile={this.isMobile}
                />
              </div>
            ))}
          </div>
        </div>
        <TypeformModal />
      </section>
    );
  }
}

export default KnowledgeBase;



// WEBPACK FOOTER //
// ./src/containers/KnowledgeBase.js